import { TypeOfWork } from "pmt-types/src/models/TypeOfWork.ts";
import { useMutationSearchEntities } from "./useMutationSearchEntities.ts";

export const useMutationSearchTypeOfWorks = () =>
  useMutationSearchEntities<TypeOfWork>("typeOfWorks");
